import React, { useState, useEffect, useCallback } from "react";
import UserProfileComponent from "./UserProfileComponent";
//import * as moment from "moment";
import * as moment from 'moment-timezone'
import ChangePasswordComponent from "../components/Shared/ChangePasswordComponent";
import TabStorage from "../helper/TabStorage";

const TIME_FORMAT = "ddd DD, MMM h:mm:ss A";
//const TIME_ZONE_FORMAT = "America/New_York";

export default function HeaderComponent() {
  const [userSession, setUserSession] = useState([]);
  const [currentTime, setCurrentTime] = useState([]);

  const [state, setState] = useState({
    changePassword: {
      renderChangePasswordModal: false,
      userId: 0,
      userName: "",
    },
  });

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }

      var userData = TabStorage.getItem("user");
      var timezoneData = TabStorage.getItem("timezone");

      setUserSession(userData);
      setCurrentTime(moment().tz(timezoneData).format(TIME_FORMAT));
      callApi();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const callApi = useCallback(async () => {
    try {
      // var changePassword = {
      //   renderChangePasswordModal: false,
      //   userId: 0,
      //   userName: "",
      // }  
      // setChangePasswordModal(changePassword);

      setInterval(() => {
        setCurrentTime(moment().tz(TabStorage.getItem("timezone")).format(TIME_FORMAT))
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const handleOnClosePasswordUpdateModal = async () => {
    try {
      let changePassword = state.changePassword;
      changePassword.renderChangePasswordModal = false;
      changePassword.userId = 0;
      changePassword.userName = "";
      setState((prev) => ({ ...prev, changePassword: changePassword }));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <nav className="main-header navbar navbar-expand navbar-white navbar-light">
        <ul className="navbar-nav">
          <li className="nav-item">
            <a
              className="nav-link pt-2"
              data-widget="pushmenu"
              href="#"
              role="button"
            >
              <i className="fas fa-bars" />
            </a>
          </li>
          <li className="nav-item">
            <h3 className="topbarheading" id="pageTitle"></h3>
          </li>
        </ul>

        <ul className="navbar-nav ml-auto">
          <li className="nav-item">
            <a className="nav-link">
              <i className="fas fa-clock"></i>&nbsp;
              <span className="topbar-clock">{currentTime}</span>
            </a>
          </li>
          {/* <li className="nav-item">
              <a className="nav-link">
                <i className="fas fa-bell"></i>
              </a>
            </li> 
            <li className="nav-item">
              <a
                className="nav-link"
                data-widget="fullscreen"
                href="#"
                role="button"
              >
                <i className="fas fa-expand-arrows-alt" />
              </a>
            </li> */}
          <li className="nav-item">
            <a
              className="nav-link dropdown-toggle"
              type="button"
              data-widget="control-sidebar"
              data-controlsidebar-slide="true"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i className="fas fa-user-circle" /> &nbsp; &nbsp;
              {userSession.firstName + " " + userSession.lastName}
            </a>
            <div className="dropdown-menu dropdown-menu-right">
              <div className="media p-3">
                <i className="fas fa-user-circle leadiconsm mr-2" />
                <div className="media-body">
                  <p className="m-0">
                    <b>
                      {userSession.firstName + " " + userSession.lastName}
                    </b>
                    <br />
                    <small>{userSession.userTypeName}</small>
                  </p>
                </div>
              </div>
              <hr className="p-0 m-0" />
              <li className="nav-item">
                <a
                  className="nav-link"
                  data-widget="pushmenu"
                  href="#"
                  role="button"
                  // onClick={() => {
                  //   ClearSessionItems();
                  //   window.location.href = "/";
                  // }}

                  onClick={(e) => {
                    const user = TabStorage.getItem("user");
                    e.preventDefault();
                    let changePassword = state.changePassword;
                    changePassword.renderChangePasswordModal = true;
                    changePassword.userId = user.userId;
                    changePassword.userName = user.userName;
                    setState((prev) => ({
                      ...prev,
                      changePassword: changePassword,
                    }));
                  }}
                >
                  <i className="fas fa-key"></i> Change Password
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  data-widget="pushmenu"
                  href="#"
                  role="button"
                  onClick={() => {
                    TabStorage.clearSessionItems();
                    window.location.href = "/";
                  }}
                >
                  <i className="fas fa-sign-out-alt"></i> Logout
                </a>
              </li>
            </div>
          </li>
        </ul>
      </nav>
      {state.changePassword.renderChangePasswordModal && (
        <ChangePasswordComponent
          userId={state.changePassword.userId}
          userName={state.changePassword.userName}
          onClose={handleOnClosePasswordUpdateModal}
        />
      )}
    </>
  );
}